<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
	<mat-icon>close</mat-icon>
</button>
<edit-child [studentId]="data.studentId" (editingTabChange)="editingTab($event)"></edit-child>